import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=e36b15dc&"
import script from "./AccountView.js?vue&type=script&lang=js&"
export * from "./AccountView.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports